<template>
    <entity-page id="page__customer" v-loader-overlay="progress">
        <template slot="header-left">
            <div class="page__customer__header-left">
                <div class="page__customer__debt">
                    <md-button
                        class="md-icon-button md-dense close small page__customer__update-btn"
                        v-on:click="getDebt"
                    >
                        <i class="fas fa-sync-alt"></i>
                        <md-tooltip md-direction="top" md-delay="500">Обновить сальдо</md-tooltip>
                    </md-button>

                    Сальдо: <b v-bind:class="{ 'value': true, 'plus': parseFloat(customer.debt_sum) > 0, 'minus': parseFloat(customer.debt_sum) < 0}"> {{ `${price.format(customer.debt_sum)} руб.` }}</b>
                </div>

                <md-button
                    v-if="customer && parseInt(customer.type) != 2"
                    v-on:click="updateCustomerFromDaData"
                    class="md-icon-button md-dense close small page__customer__update-btn"
                >
                    <i class="fas fa-sync-alt"></i>
                    <md-tooltip md-direction="top" md-delay="500">Обновить данные из DaData</md-tooltip>
                </md-button>

                <span v-if="parseInt(customer.liquidated) == 1" class="liquidated">
                    Ликвидирован
                    <span v-if="liquidationDate">{{ liquidationDate }}</span>
                </span>
                <span v-else-if="customer.hid">Реквизиты успешно проверены</span>
                <span v-else-if="!customer.hid && parseInt(customer.type) != 2">Реквизиты не были проверены!</span>
            </div>
        </template>
        <template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded v-on:click="back"></z-icon-button>
            <z-icon-button v-bind:icon="['fa', 'check']" success-light rounded v-on:click="save"></z-icon-button>
        </template>
        <template slot="default" v-if="(typeof customer.id !== 'undefined')">
            <flex-tabs
                v-if="customer.id"
                v-bind:tabs="tabs"
                v-model="activeTab"
                v-on:change="changeActiveTab"
                min prevent-input
            ></flex-tabs>
            <customer-information v-show="activeTab == 'tab-information'" v-model="customer" ref="information"></customer-information>
            <customer-address     v-show="activeTab == 'tab-address'"     v-model="customer.addresses" v-bind:customer-id="parseInt(customer.id)"></customer-address>
            <customer-contacts    v-show="activeTab == 'tab-contacts'"    v-model="customer.contacts"  v-bind:customer-id="parseInt(customer.id)" ref="contacts"></customer-contacts>
            <customer-finance     v-show="activeTab == 'tab-finance'"     v-bind:customer-id="parseInt(customer.id)" v-if="customer.id && activeTab == 'tab-finance'"></customer-finance>
            <comments-and-logs    v-show="activeTab == 'tab-history'"     v-bind:entity_id="parseInt(customer.id)"   v-bind:entity="historyEntity" ref="history" module="customers"></comments-and-logs>
        </template>
    </entity-page>
</template>
<script>
    import price from '@/helpers/price';
    import FlexTabs    from '@/components/FlexTabs.vue';
    import EntityPage  from '@/components/EntityPage.vue';
    import ZIconButton from '@/components/ZIconButton.vue';
    import CustomerAddress  from '../components/CustomerAddress.vue';
    import CustomerContacts from '../components/CustomerContacts.vue';
    import CustomerFinance  from '../components/CustomerFinance.vue';
    import commentsAndLogs  from '@/components/CommentsAndLogs';
    import CustomerInformation from '../components/CustomerInformation.vue';
    export default {
        components: { ZIconButton, commentsAndLogs, FlexTabs, EntityPage, CustomerInformation, CustomerAddress, CustomerContacts, CustomerFinance },
        data() {
            return {
                price: price,
                customer: {},
                customerDefault: {
                    id: null,
                    name: null,
                    inn: null,
                    kpp: null,
                    passport_number: null,
                    is_agent: 0,
                    contacts: [],
                    addresses: []
                },
                tabs: [
                    {name: "tab-information", label: "Информация"},
                    {name: "tab-address",   label: "Адреса"},
                    {name: "tab-contacts",  label: "Контактные лица"},
                    {name: "tab-finance",      label: "Финансы"},
                    {name: "tab-history",     label: "История"},
                ],
                activeTab: 'tab-information'
            }
        },
        created() {
            this.init();
        },
        watch: {
            '$route.params.customer_id' () {
                this.init();
            }
        },
        computed: {
            /**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['load-customer-card'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            },
            /**
             * Вывод заголовка у истории
             */
            historyEntity() {
                return parseInt(this.customer.type) === 2 ? 'customersfiz' : 'customersur';
            },
            liquidationDate() {
                if (!this.customer.liquidation_date) return null;
                return this.moment(this.customer.liquidation_date).format('DD.MM.YYYY')
            }
        },
        methods: {
            /**
             * Инициализация компонента
             */
            init() {
                this.$store.commit('openRightPanel');
                this.$store.commit('setRightPanelWidth', 1100);

                if (this.$route.hash && (this.$route.hash.indexOf('tab-')+1))
                    this.changeActiveTab(this.$route.hash.slice(1));

                if (this.$route.params.customer_id != 'new') {
                    this.customer = Object.assign({}, this.customerDefault);
                    this.getCustomer();
                } else this.customer = Object.assign({}, this.customerDefault);
            },
            /**
             * Получение контрагента
             */
            getCustomer() {
                this.$store.commit('showProgressBar', 'load-customer-card');
                return this.$store.dispatch('customers/getCustomerById', this.$route.params.customer_id).then(r => {
                    if (!r) return;
                    this.customer = this.resolveCustomer(r);
                }).finally(() => this.$store.commit('hideProgressBar', 'load-customer-card'));
            },
            /**
             * Обработка объекта контрагента
             */
            resolveCustomer(customer) {
                if (!customer.addresses) customer.addresses = [];
                if (!customer.contacts) customer.contacts = [];
                customer.type = parseInt(customer.type);
                customer.nds = parseInt(customer.nds);
                customer.is_agent = parseInt(customer.is_agent);

                return Object.assign({}, customer);
            },
            /**
             * Изменение активного таба
             */
            changeActiveTab(value) {
                this.activeTab = value;
                this.$router.replace({name: this.$route.name, params: this.$route.params, query: this.$route.query, hash: `#${value}` });
            },
            /**
             * Возвращает пользователя на предидущую страницу
             */
            back() {
                this.$router.push({name: 'Customers', query: this.$route.query});
            },
            /**
             * Изменение контрагента
             */
            putCustomer() {
                this.$store.commit('showProgressBar', 'load-customer-card');
                this.$store.dispatch('customers/updateCustomer', { customer: this.customer })
                    .then(() => this.$root.$emit('reload-table', 'customers'))
                    .finally(() => this.$store.commit('hideProgressBar', 'load-customer-card'));
            },
            /**
             * Добавление контрагента
             */
            postCustomer() {
                this.$store.commit('showProgressBar', 'load-customer-card');
                this.$store.dispatch('customers/addCustomer', { customer: this.customer }).then(r => {
                    if (!r) return;
                    this.$root.$emit('reload-table', 'customers'),
                    this.$router.replace({name: 'Customer', params: {customer_id: r.id}});
                }).finally(() => this.$store.commit('hideProgressBar', 'load-customer-card'));
            },
            /**
             * Сохранение контрагента
             */
            save() {
                this.validate().then(valid => {
                    if (!valid) return; 
                    if (this.$route.params.customer_id != 'new') this.putCustomer();
                    else this.postCustomer();
                });
            },
            /**
             * Валидация
             */
            async validate() {
                return await Promise.all(['contacts', 'information'].map(n => this.$refs[n].validate())).then(r => r.every(n => !!n));
            },
            /**
             * Обновление контрагента из ДаДата
             */
            async updateCustomerFromDaData() {
                this.$store.commit('showProgressBar', 'load-customer-card');
                await this.$store.dispatch('customers/updateCustomerFromDaData', this.$route.params.customer_id).catch(() => null);
                await this.getCustomer().catch(() => null);
                this.$store.commit('hideProgressBar', 'load-customer-card')
            },
            getDebt() {
                this.$store.commit('showProgressBar', 'load-customer-card');
                this.$store.dispatch('finance/getDebt', {id: this.customer.id}).then(debt => {
                    if (debt) this.customer.debt_sum = debt.sum;
                }).finally(() => this.$store.commit('hideProgressBar', 'load-customer-card'));
            },
        },
    }
</script>
<style lang="sass">
#page__customer
    .page__customer__header-left
        display: flex
        align-items: center
        justify-content: center
        .liquidated
            color: red
        .page__customer__debt
            display: flex
            align-items: center
            justify-content: center
            margin: 0 10px 0 0
            .value
                margin: 0 0 0 5px
                &.plus
                    color: green
                &.minus
                    color: red
            .page__customer__update-btn
                margin: 0 5px 0 0
</style>


// WEBPACK FOOTER //
// Customer.vue?2637055c